import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form/immutable'
import { Map, List } from 'immutable'
import i18next from 'i18next'
import { withTranslation } from 'react-i18next'

import {
  getOrganizationTeams,
  getOrganizationUsersOrganizationId,
  getOrganizationUsersSelectedOrganizationAvailableProTrackLevels,
} from 'store/entities/organizations/selectors'
import { fetchAvailableProTrackLevelsForSelectedOrg, manageProTrackLevels } from 'store/entities/organizations/actions'
import withDidMountRequest from 'app/connectors/withDidMountRequest'
import ManageProTracksForm from './ManageProTracksForm'

export const FORM_NAME = 'SWITCH_PROTRACK_FORM'
const formSelector = formValueSelector(FORM_NAME)

const formProps = {
  form: FORM_NAME,
  initialValues: Map({
    entireOrg: false,
    teams: List(),
    proTrackLevelId: '0',
    emails: '',
  }),
  onSubmit: (values, dispatch, { selectedOrgId, isSwitchProTrackLevelForm }) => {
    const data = values.toJS()
    data.organizationId = selectedOrgId
    if (isSwitchProTrackLevelForm) {
      data.proTrackLevelId = parseInt(data.proTrackLevelId)
    } else {
      delete data.proTrackLevelId
    }
    dispatch(manageProTrackLevels({ data, isSwitchProTrackLevelForm }))
  },
}

const mapStateToProps = state => {
  const teamsOptions = getOrganizationTeams(state).toJS()
  return {
    teams: teamsOptions,
    selectedOrgId: getOrganizationUsersOrganizationId(state),
    proTrackLevels: getOrganizationUsersSelectedOrganizationAvailableProTrackLevels(state),
    isEntireOrg: formSelector(state, 'entireOrg'),
    emailsValue: formSelector(state, 'emails'),
    teamsValue: formSelector(state, 'teams'),
  }
}

const mapDispatchToProps = {
  fetchAvailableProTrackLevelsForSelectedOrg,
}

const mergeProps = (
  { selectedOrgId, proTrackLevels, emailsValue, teamsValue, isEntireOrg, ...stateProps },
  { fetchAvailableProTrackLevelsForSelectedOrg },
  { t, ...ownProps }
) => {
  const proTrackLevelOption = i18next.t('Please select')
    ? `${i18next.t('Please select')} ${i18next.t('ProTrackLevel')}`
    : 'Please select ProTrackLevel'
  return {
    ...stateProps,
    ...ownProps,
    proTrackLevels: typeof proTrackLevels === 'object' ? proTrackLevels.unshift(proTrackLevelOption) : '0',
    onRequest: () => fetchAvailableProTrackLevelsForSelectedOrg(selectedOrgId),
    isWaitingProTrackLevels: !proTrackLevels.size,
    selectedOrgId,
    isEmailsEnter: typeof emailsValue === 'string' ? !!emailsValue.length : false,
    isTeamsEnter: typeof teamsValue === 'object' ? !!teamsValue.size : false,
    isEntireOrg: typeof isEntireOrg === 'boolean' ? isEntireOrg : false,
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
  reduxForm(formProps)(withDidMountRequest(withTranslation()(ManageProTracksForm)))
)
